
const DateUtil = {};

// 根据日期转换成字符串形式
DateUtil.getDateString = function (date) {
  const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : `0${(date.getMonth() + 1)}`;
  const day = (date.getDate()) > 9 ? (date.getDate()) : `0${(date.getDate())}`;
  const hour = (date.getHours()) > 9 ? (date.getHours()) : `0${(date.getHours())}`;
  const minutes = (date.getMinutes()) > 9 ? (date.getMinutes()) : `0${(date.getMinutes())}`;
  const seconds = (date.getSeconds()) > 9 ? (date.getSeconds()) : `0${(date.getSeconds())}`;
  return `${date.getFullYear()}-${month}-${day} ${hour}:${minutes}:${seconds}`;
};

DateUtil.getTr069DateString = function (date) {
  const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : `0${(date.getMonth() + 1)}`;
  const day = (date.getDate()) > 9 ? (date.getDate()) : `0${(date.getDate())}`;
  const hour = (date.getHours()) > 9 ? (date.getHours()) : `0${(date.getHours())}`;
  const minutes = (date.getMinutes()) > 9 ? (date.getMinutes()) : `0${(date.getMinutes())}`;
  const seconds = (date.getSeconds()) > 9 ? (date.getSeconds()) : `0${(date.getSeconds())}`;
  return `${date.getFullYear()}-${month}-${day}T${hour}:${minutes}:${seconds}`;
};

// 获取年月日
DateUtil.getYearMonthDay = function (date) {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : `0${(date.getMonth() + 1)}`;
  const day = (date.getDate()) > 9 ? (date.getDate()) : `0${(date.getDate())}`;
  return `${year}-${month}-${day}`;
}

// 获取当前的年月日
DateUtil.getTodayYearMonthDay = function () {
  return this.getYearMonthDay(new Date());
};

// 获取昨天的年月日
DateUtil.getYesterdayYearMonthDay = function () {
  const nowDate = new Date();
  const yesterday = new Date();
  const yesterdayMilliseconds = nowDate.getTime() - 1000 * 60 * 60 * 24;
  yesterday.setTime(yesterdayMilliseconds);
  return this.getYearMonthDay(yesterday);
};

// 获取本周周一的年月日
DateUtil.getCurrentWeekBeginYearMonthDay = function () {
  const nowDate = new Date();
  const thisWeekDateBegin = new Date();
  const sequenceNumOfToday = nowDate.getDay() === 0 ? 7 : nowDate.getDay();
  const currentWeekFirstDateMilliseconds = nowDate.getTime() - 1000 * 60 * 60 * 24 * (sequenceNumOfToday - 1);
  thisWeekDateBegin.setTime(currentWeekFirstDateMilliseconds);
  return this.getYearMonthDay(thisWeekDateBegin);
};

// 获取本周周日的年月日
DateUtil.getCurrentWeekEndYearMonthDay = function () {
  const nowDate = new Date();
  const thisWeekDateEnd = new Date();
  const sequenceNumOfToday = nowDate.getDay() === 0 ? 7 : nowDate.getDay();
  const currentWeekFirstDateMilliseconds = nowDate.getTime() + 1000 * 60 * 60 * 24 * (7 - sequenceNumOfToday);
  thisWeekDateEnd.setTime(currentWeekFirstDateMilliseconds);
  return this.getYearMonthDay(thisWeekDateEnd);
};

// 获取上周周一的年月日
DateUtil.getLastWeekBeginYearMonthDay = function () {
  const nowDate = new Date();
  const thisWeekDateBegin = new Date();
  const sequenceNumOfToday = nowDate.getDay() === 0 ? 7 : nowDate.getDay();
  const currentWeekFirstDateMilliseconds = nowDate.getTime() - 1000 * 60 * 60 * 24 * (sequenceNumOfToday + 6);
  thisWeekDateBegin.setTime(currentWeekFirstDateMilliseconds);
  return this.getYearMonthDay(thisWeekDateBegin);
};

// 获取上周周日的年月日
DateUtil.getLastWeekEndYearMonthDay = function () {
  const nowDate = new Date();
  const thisWeekDateEnd = new Date();
  const sequenceNumOfToday = nowDate.getDay() === 0 ? 7 : nowDate.getDay();
  const currentWeekFirstDateMilliseconds = nowDate.getTime() - 1000 * 60 * 60 * 24 * sequenceNumOfToday;
  thisWeekDateEnd.setTime(currentWeekFirstDateMilliseconds);
  return this.getYearMonthDay(thisWeekDateEnd);
};

export default DateUtil;
